// constants.js
export const BUY_NOW = 'BUY_NOW';
export const RESET = 'RESET';
export const SUCCESS = 'SUCCESS';
